module.exports = __webpack_public_path__ + "static/media/manual_05.9efdf5be.jpg";